import type { StepEmails } from './launchStepSources';
import type { LaunchGuardEmail } from '@/pages/CycleEvaluation/LaunchSummary/launchGuard';

import { isEmailBodyEmpty } from '@/pages/CycleEvaluation/LaunchSummary/launchGuard';
import { resolveEmailBody } from '@/pages/CycleEvaluation/LaunchSummary/launchSummaryFormatting';

// Must consume `stepEmails` as already resolved by `readStepEmails`: a communications-layer
// milestone has nothing under the legacy `CycleSchedule` fields, so re-deriving from those
// would always read it as empty.
export const buildGuardEmail = (stepEmails: StepEmails | undefined): LaunchGuardEmail => ({
    enabled: !!stepEmails?.managerEmail?.isEnabled,
    isBodyEmpty: isEmailBodyEmpty(resolveEmailBody(stepEmails?.managerEmail?.bodyByLocale)),
});
